import React from 'react';
import "./skillpanel.css";

function skillpanel() {
  return (

<section class="skills">
<div className="skill" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
    <div className="skill-name">HTML</div>
    <div className="skill-bar">
      <div className="skill-per" per="91%" style={{ maxWidth: "91%" }} />
    </div>
  </div>
  <div className="skill" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
    <div className="skill-name">CSS / SCSS</div>
    <div className="skill-bar">
      <div className="skill-per" per="86%" style={{ maxWidth: "86%" }} />
    </div>
  </div>
  <div className="skill" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
    <div className="skill-name">Bootstrap</div>
    <div className="skill-bar">
      <div className="skill-per" per="81%" style={{ maxWidth: "81%" }} />
    </div>
  </div>
  <div className="skill" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
    <div className="skill-name">Javascript</div>
    <div className="skill-bar">
      <div className="skill-per" per="65%" style={{ maxWidth: "65%" }} />
    </div>
  </div>
  <div className="skill" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
    <div className="skill-name">React</div>
    <div className="skill-bar">
      <div className="skill-per" per="72%" style={{ maxWidth: "72%" }} />
    </div>
  </div>
  <div className="skill"data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
    <div className="skill-name">Next.js</div>
    <div className="skill-bar">
      <div className="skill-per" per="58%" style={{ maxWidth: "58%" }} />
    </div>
  </div>
  <div className="skill" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
    <div className="skill-name">SQL</div>
    <div className="skill-bar">
      <div className="skill-per" per="61%" style={{ maxWidth: "61%" }} />
    </div>
  </div>


</section>
  )
}

export default skillpanel;